"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _clientAwsS = require("@devsta/client-aws-s3");

var _uiKit = require("@devsta/ui-kit");

var _reactRouterDom = require("react-router-dom");

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _OutputMetadata = _interopRequireDefault(require("./OutputMetadata"));

var _ShareIntegration = _interopRequireDefault(require("./ShareIntegration"));

var _RelatedOutputs = _interopRequireDefault(require("./RelatedOutputs"));

var _ShareModal = _interopRequireDefault(require("./ShareModal"));

var _PostsModal = _interopRequireDefault(require("./PostsModal"));

var _PublishPostNotice = _interopRequireDefault(require("./PostsModal/components/PublishPostNotice"));

require("../styles/_completed-video.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getDate = function getDate(date) {
  return (0, _moment.default)(date).format('YYYY/MM/DD [at] hh:mm A');
};

var CompletedVideo = /*#__PURE__*/function (_Component) {
  _inherits(CompletedVideo, _Component);

  var _super = _createSuper(CompletedVideo);

  function CompletedVideo() {
    var _this;

    _classCallCheck(this, CompletedVideo);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, getVideo, outputId, fetchAssets, fetchCollaborationData, _yield$getVideo, data, error, videoData, getProjectForVideo, output, assetIds;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, getVideo = _this$props.getVideo, outputId = _this$props.outputId, fetchAssets = _this$props.fetchAssets, fetchCollaborationData = _this$props.fetchCollaborationData;
              _context.next = 3;
              return getVideo();

            case 3:
              _yield$getVideo = _context.sent;
              data = _yield$getVideo.data;
              error = _yield$getVideo.error;

              if (!(!data || error || !data.getVideo || !data.getProjectForVideo)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                error: true,
                loading: false
              }));

            case 8:
              videoData = data.getVideo, getProjectForVideo = data.getProjectForVideo;
              output = videoData.outputs.find(function (singleOutput) {
                return outputId === singleOutput.outputId;
              });
              assetIds = videoData.outputs.map(function (singleOutput) {
                var _ref2 = singleOutput.versions[output.latestVersion - 1] || {},
                    assetId = _ref2.assetId;

                return assetId;
              }).filter(Boolean);
              fetchAssets({
                assetIds: assetIds
              });
              fetchCollaborationData(videoData.organisationId);

              if (output.assignedEditorId) {
                _this.fetchEditor(output.assignedEditorId, videoData.organisationId);
              }

              if (output.inspirationId) {
                _this.fetchInspiration(output.inspirationId);
              } // We've removed Ratings until the business requirements are reworked
              // this.fetchOutputRating();


              _this.setState({
                output: output,
                video: videoData,
                project: getProjectForVideo,
                finalVersion: output.versions[output.versions.length - 1]
              }, function () {
                _this.setState({
                  loading: false
                });
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchEditor", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(editorId, organisationId) {
        var _this$props2, getEditor, apiClient, _yield$getEditor, data, error, editor;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = _this.props, getEditor = _this$props2.getEditor, apiClient = _this$props2.apiClient;
                _context2.next = 3;
                return getEditor(editorId);

              case 3:
                _yield$getEditor = _context2.sent;
                data = _yield$getEditor.data;
                error = _yield$getEditor.error;

                if (!(!data || error || !data.getUser)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return");

              case 8:
                _context2.prev = 8;
                _context2.next = 11;
                return (0, _clientAwsS.replaceBucketKeysWithUrls)({
                  apiClient: apiClient,
                  data: data.getUser,
                  substitutedKeys: ['imageUrl'],
                  organisationId: organisationId
                });

              case 11:
                editor = _context2.sent;

                _this.setState({
                  assignedEditor: editor
                });

                _context2.next = 17;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](8);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[8, 15]]);
      }));

      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "fetchInspiration", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(inspirationId) {
        var getInspiration, _yield$getInspiration, data, error;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                getInspiration = _this.props.getInspiration;
                _context3.next = 3;
                return getInspiration(inspirationId);

              case 3:
                _yield$getInspiration = _context3.sent;
                data = _yield$getInspiration.data;
                error = _yield$getInspiration.error;

                if (!(!data || error || !data.getInspiration)) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return");

              case 8:
                _this.setState({
                  inspirationDetails: data.getInspiration
                });

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "goToVideoBrief", function () {
      var history = _this.props.history;
      var video = _this.state.video;

      if (!video) {
        return;
      }

      var videoId = video.videoId;
      history.push("/builder/".concat(videoId));
    });

    _defineProperty(_assertThisInitialized(_this), "goToVersionHistory", function (_ref5) {
      var allowRequestChanges = _ref5.allowRequestChanges;
      var _this$props3 = _this.props,
          history = _this$props3.history,
          outputId = _this$props3.outputId;
      var video = _this.state.video;

      if (!video) {
        return;
      }

      var videoId = video.videoId;
      history.rootPush({
        pathname: "/review/".concat(videoId, "/").concat(outputId),
        search: allowRequestChanges ? '?requestChanges' : ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "goToVersionHistoryWithReqChanges", function () {
      _this.goToVersionHistory({
        allowRequestChanges: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "goToVersionHistoryPage", function () {
      _this.goToVersionHistory({
        allowRequestChanges: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeShowPublishNotice", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var addedInspirationId;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              addedInspirationId = _this.state.addedInspirationId;

              _this.setState({
                showPublishNotice: false
              });

              if (!addedInspirationId) {
                _context4.next = 5;
                break;
              }

              _context4.next = 5;
              return _this.fetchInspiration(addedInspirationId);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "goToInspiration", function () {
      var history = _this.props.history;
      var _this$state$inspirati = _this.state.inspirationDetails;
      _this$state$inspirati = _this$state$inspirati === void 0 ? {} : _this$state$inspirati;
      var inspirationId = _this$state$inspirati.inspirationId,
          status = _this$state$inspirati.status;

      if (!inspirationId) {
        return;
      }

      if (status === 'PUBLISHED') {
        history.rootPush("/inspiration#".concat(inspirationId));
        return;
      }

      history.rootPush("/inspiration/manage#".concat(inspirationId));
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeStatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var updateInspiration, addedInspirationId;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              updateInspiration = _this.props.updateInspiration;
              addedInspirationId = _this.state.addedInspirationId;
              _context5.prev = 2;
              _context5.next = 5;
              return updateInspiration({
                inspirationId: addedInspirationId,
                input: {
                  status: 'PUBLISHED'
                }
              });

            case 5:
              _context5.next = 10;
              break;

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](2);
              (0, _commonReact.notify)({
                content: 'Something went wrong.',
                type: 'error'
              });

            case 10:
              return _context5.abrupt("return", _this.closeShowPublishNotice());

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 7]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "openShareModal", function () {
      _this.setState({
        shareModalVisible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeShareModal", function () {
      _this.setState({
        shareModalVisible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openPostModal", function () {
      _this.setState({
        isPostModalVisible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closePostModal", function (addedInspirationId) {
      _this.setState({
        isPostModalVisible: false
      });

      if (addedInspirationId) {
        _this.setState({
          addedInspirationId: addedInspirationId,
          showPublishNotice: true
        });
      }
    });

    _this.state = {
      shareModalVisible: false,
      error: false,
      loading: true,
      isPostModalVisible: false,
      showPublishNotice: false,
      addedInspirationId: void 0
    };
    return _this;
  }

  _createClass(CompletedVideo, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          output = _this$state.output,
          video = _this$state.video,
          project = _this$state.project,
          finalVersion = _this$state.finalVersion,
          error = _this$state.error,
          loading = _this$state.loading,
          shareModalVisible = _this$state.shareModalVisible,
          assignedEditor = _this$state.assignedEditor,
          isPostModalVisible = _this$state.isPostModalVisible,
          showPublishNotice = _this$state.showPublishNotice,
          inspirationDetails = _this$state.inspirationDetails;
      var _this$props4 = this.props,
          outputId = _this$props4.outputId,
          showShareModal = _this$props4.showShareModal,
          history = _this$props4.history,
          membershipOrgIds = _this$props4.membershipOrgIds,
          orgPermissions = _this$props4.orgPermissions,
          size = _this$props4.size;

      if (error) {
        return (/*#__PURE__*/_react.default.createElement(_commonReact.Error, null)
        );
      }

      if (loading) {
        return (/*#__PURE__*/_react.default.createElement(_uiKit.Loader, null)
        );
      }

      if (!output || !video || !project || !finalVersion) {
        return (/*#__PURE__*/_react.default.createElement(_commonReact.NotFound, {
            history: history
          })
        );
      }

      var outputName = (0, _getVideoOutputName.default)(output, video.name);
      var numberOfRelatedOutputs = video.outputs.length - 1;
      var hasResourceOrgMembership = membershipOrgIds.includes(video.organisationId);
      var hasMaxVersions = output.versions.length >= 5;
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "completed-video page"
        }, hasResourceOrgMembership ? /*#__PURE__*/_react.default.createElement(_ShareModal.default, {
          visible: shareModalVisible,
          onClose: this.closeShareModal,
          organisationId: video.organisationId,
          outputId: outputId,
          video: video
        }) : null, hasResourceOrgMembership && isPostModalVisible && /*#__PURE__*/_react.default.createElement(_PostsModal.default, {
          isPostModalVisible: isPostModalVisible,
          onClose: this.closePostModal,
          organisationId: video.organisationId,
          assetId: finalVersion.assetId,
          outputId: outputId
        }), showPublishNotice && /*#__PURE__*/_react.default.createElement(_PublishPostNotice.default, {
          visible: showPublishNotice,
          onClose: this.closeShowPublishNotice,
          onSave: this.onChangeStatus
        }), /*#__PURE__*/_react.default.createElement(_commonReact.CollaborationPageHeader, {
          actionPopupBackgroundColor: "bigFat",
          title: outputName,
          subtitle: project.name
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "column"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "completed-video__video"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "completed-video__video__player"
        }, /*#__PURE__*/_react.default.createElement(_commonReact.Player, {
          assetId: finalVersion.assetId
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "completed-video__video__content"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "completed-video__video__content__summary"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "completed-video__video__content__summary__title"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "video",
          color: "russian",
          size: 20
        }), /*#__PURE__*/_react.default.createElement("p", null, outputName), output.isMaster ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "master",
          color: "goldenTainoi",
          size: 20
        }) : null), /*#__PURE__*/_react.default.createElement("p", {
          className: (0, _classnames.default)('completed-video__video__content__summary__version', {
            'completed-video__video__content__summary__version--small': size.width < 1125
          })
        }, /*#__PURE__*/_react.default.createElement("strong", null, "Version ".concat("".concat(output.latestVersion).padStart(2, '0'))), "- Completed ".concat((0, _moment.default)(output.completedAt, 'x').format('Do MMMM YYYY [at] h:mma'))), /*#__PURE__*/_react.default.createElement("span", {
          className: "completed-video__video__content__summary__project"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "link",
          size: 10,
          color: "nevada"
        }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: "/video-tool/project/".concat(project.videoProjectId)
        }, project.name))), /*#__PURE__*/_react.default.createElement("div", {
          className: "completed-video__video__content__actions"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('completed-video__video__content__actions__buttons', {
            'completed-video__video__content__actions__buttons--small': size.width < _vars.NUMERIC_MEDIA_SIZES.medium
          })
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
          small: true,
          onClick: this.goToVideoBrief,
          type: "SECONDARY"
        }, "VIEW VIDEO BRIEF"), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
          small: true,
          onClick: this.goToVersionHistoryPage,
          type: "SECONDARY"
        }, "VIEW VERSION HISTORY"), hasMaxVersions ? null : /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
          small: true,
          onClick: this.goToVersionHistoryWithReqChanges,
          type: "SECONDARY"
        }, "REOPEN VIDEO")))), hasResourceOrgMembership ? /*#__PURE__*/_react.default.createElement("div", {
          className: "completed-video__video__share"
        }, /*#__PURE__*/_react.default.createElement("p", null, "SHARE TO"), /*#__PURE__*/_react.default.createElement("div", {
          className: "completed-video__video__share__integrations"
        }, /*#__PURE__*/_react.default.createElement(_ShareIntegration.default, {
          icon: "link",
          text: "SHARE LINK",
          subtitle: "Share to people you know",
          onClick: showShareModal
        }), /*#__PURE__*/_react.default.createElement(_ShareIntegration.default, {
          icon: "web",
          text: "SHARE TO THE WEB",
          subtitle: "Share your video to other sites",
          onClick: this.openShareModal
        }), inspirationDetails && inspirationDetails.inspirationId && /*#__PURE__*/_react.default.createElement(_ShareIntegration.default, {
          icon: "inspiration",
          text: "VIEW INSPIRATION POST",
          subtitle: "Updated at ".concat(getDate(inspirationDetails.updatedAt)),
          onClick: this.goToInspiration
        }), !inspirationDetails && (0, _commonReact.hasPermission)('CREATE_FROM_VIDEO', orgPermissions) && /*#__PURE__*/_react.default.createElement(_ShareIntegration.default, {
          icon: "inspiration",
          text: "POST TO INSPIRATIONS",
          subtitle: "Inspire your Organisation",
          onClick: this.openPostModal
        }))) : null), /*#__PURE__*/_react.default.createElement("div", {
          className: "completed-video__more-info"
        }, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_uiKit.Accordion, {
          titles: ['File Data', numberOfRelatedOutputs ? "Related Videos (".concat(numberOfRelatedOutputs, ")") : void 0]
        }, /*#__PURE__*/_react.default.createElement(_OutputMetadata.default, {
          assetId: finalVersion.assetId,
          assignedEditor: assignedEditor
        })), /*#__PURE__*/_react.default.createElement(_RelatedOutputs.default, {
          outputs: video.outputs,
          videoName: video.name,
          currentOutput: output,
          history: history,
          videoId: video.videoId
        }))))
      );
    }
  }]);

  return CompletedVideo;
}(_react.Component);

exports.default = CompletedVideo;